import { Divider, Table } from '@scuf/common';
import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function ContractsPage() {
    const [width, setWidth] = useState<number>(0);

    const { t } = useTranslation(['contracts']);

    function handleResize() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        document.title = 'Centro de Reparos - Portal Honeywell';
        setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    }, []);

    usePreventClickjacking();

    return (
        <>
            <div className="container2">
                <div className="contentPageContainer2">
                    <div className="container-grande2">
                        <h4>{t('contracts:translation.title1')}</h4>
                        <p>{t('contracts:translation.text1')}</p>
                        <h4>{t('contracts:translation.title2')}</h4>
                        <p>{t('contracts:translation.text2')}</p>
                        <p>{t('contracts:translation.text3')}</p>
                        <ul className="column">
                            <li>{t('contracts:translation.l1')}</li>
                            <li>{t('contracts:translation.l2')}</li>
                            <li>{t('contracts:translation.l3')}</li>
                            <li>{t('contracts:translation.l4')}</li>
                        </ul>
                        <p>{t('contracts:translation.text4')}</p>
                        <h4>{t('contracts:translation.title4')}</h4>
                        <ul className="column">
                            <li>{t('contracts:translation.l5')}</li>
                            <li>{t('contracts:translation.l6')}</li>
                            <li>{t('contracts:translation.l7')}</li>
                            <li>{t('contracts:translation.l8')}</li>
                        </ul>
                        <h4>{t('contracts:translation.title5')}</h4>
                        <ul className="column">
                            <li>{t('contracts:translation.l9')}</li>
                            <li>{t('contracts:translation.l10')}</li>
                            <li>{t('contracts:translation.l11')}</li>
                        </ul>
                        <h4>{t('contracts:translation.title6')}</h4>
                        <ul className="column">
                            <li>{t('contracts:translation.l12')}</li>
                            <li>{t('contracts:translation.l13')}</li>
                        </ul>
                    </div>
                </div>
                <div className="contentPageContainer2">
                    <div className="container-grande2">
                        <h4>{t('contracts:translation.title3')}</h4>
                        <Table>
                            <Table.Header>
                                <Table.HeaderCell content={t('common:translation.Description')} />
                                <Table.HeaderCell content={t('contracts:translation.coberturaP')} />
                                <Table.HeaderCell content={t('contracts:translation.CoberturaG')} />
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item1')} </Table.Cell>
                                    <Table.Cell>{t('contracts:translation.day3')} </Table.Cell>
                                    <Table.Cell>{t('contracts:translation.day5')} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item2')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item3')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item4')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{<li>{t('contracts:translation.item5')}</li>} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{<li>{t('contracts:translation.item6')}</li>} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{<li>{t('contracts:translation.item7')}</li>} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item8')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item9')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item10')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item11')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item12')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item13')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>{t('contracts:translation.item14')} </Table.Cell>
                                    <Table.Cell>{'X'} </Table.Cell>
                                    <Table.Cell>{'-'} </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </div>
                </div>
            </div>

            {/* <AboutContainer /> */}
        </>
    );
}

export default ContractsPage;
